import React from 'react';
import { TrendingUp, Users, Target, Award } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: Target,
      value: '50K+',
      label: 'Campaigns Delivered',
      description: 'Successful campaigns across all channels',
    },
    {
      icon: Users,
      value: '95%',
      label: 'Client Retention',
      description: 'Long-term partnerships built on results',
    },
    {
      icon: TrendingUp,
      value: '3.5x',
      label: 'Average ROI',
      description: 'Data-driven performance optimization',
    },
    {
      icon: Award,
      value: '10+',
      label: 'Years Experience',
      description: 'Industry-leading expertise',
    },
  ];

  return (
    <section className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="group relative bg-slate-900/40 backdrop-blur-xl border border-slate-800/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:scale-105"
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-cyan-500/10 border border-cyan-500/20 group-hover:bg-cyan-500/20 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-cyan-400" />
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-2">
                  <h3 className="text-4xl font-bold text-white">{stat.value}</h3>
                  <p className="text-lg font-semibold text-slate-200">{stat.label}</p>
                  <p className="text-sm text-slate-400 leading-relaxed">{stat.description}</p>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;
